import Layout from "components/Layout";
import { useGetMonitoringCount } from "hooks/apis/question";
import { useLocation } from "react-router-dom";

const MonitoringPage = () => {
  const { data } = useGetMonitoringCount();
  const location = useLocation();
  const pathname = location.pathname;
  const search = decodeURI(location.search);

  return (
    <Layout
      title="모니터링"
      nav={[
        {
          label: "조교",
          links: [
            {
              label: "실시간 접속 현황",
              path: "/monitoring/assistant",
              isActive: pathname.includes("/monitoring/assistant"),
            },
          ],
        },
        {
          label: "조교 작업 모니터링",
          links: [
            {
              label: "대기중",
              path: "/monitoring/work/ongoing",
              count: data?.onGoingCount,
              isActive:
                pathname.includes("/monitoring/work/ongoing") ||
                search.includes("status=대기중"),
            },
            {
              label: "검수 완료",
              path: "/monitoring/work/completed",
              isActive:
                pathname.includes("/monitoring/work/completed") ||
                search.includes("status=완료"),
            },
          ],
        },
      ]}
    />
  );
};

export default MonitoringPage;
